module.exports = __webpack_public_path__ + "img/ic_group_order_shopping_bag_full.cb0006a7.png";